import { useAuthenticatedQuery } from 'flow/hooks/api/useAuthenticatedQuery';
import ChatsResource from 'flow/api/chats';
import { ChatSessionKey } from 'flow/types/EntityKeys';
import { SummarizeMessage, SummaryOption } from 'flow/types/SummarizeMessage';
import { getSummaryValue } from 'flow/utils/chat-utils';

export const useSummarizeChatMessages = (
    chatSessionKey: ChatSessionKey,
    summaryOption: SummaryOption,
) => {
    const { from, to, read } = getSummaryValue(summaryOption);

    return useAuthenticatedQuery<SummarizeMessage, { response: string }>({
        queryKey: ['chatSummary', chatSessionKey, summaryOption],
        queryFn: () =>
            new Promise((resolve, reject) => {
                ChatsResource.summarizeChatMessages(
                    {
                        onResult: resolve,
                        onError: reject,
                        onClientError: reject,
                    },
                    chatSessionKey,
                    from,
                    to,
                    read,
                );
            }),
        enabled: !!chatSessionKey && !!summaryOption,
        staleTime: read === 'false' ? 0 : 300000,
    });
};
